import { Map, View } from 'ol';
import { fromLonLat } from 'ol/proj';
import { defaults as defaultControls } from 'ol/control';

let map; 

export function createMap(properties = {}) {
  if (map) return map; // singleton

  map = new Map({
    target: 'map',
    view: new View({
      // Bewonersbrief: België als vertrekpunt (index.html past de exacte
      // omhullende toe zodra de kaart er is).
      center: fromLonLat([4.65, 50.65]),
      zoom: 8,
    }),
    controls: defaultControls()
  });

  map.setProperties(properties);

  document.dispatchEvent(
    new CustomEvent('map-ready', { detail: map })
  );

  return map;
}

export function getMap() {

  if (!map) {
    console.error('getMap() called before map creation', new Error().stack);
  }

  return map;
}
